import * as actionTypes from "../../actionLabels/index";

export const fetchEnglishAuctionHeaderDataRequest = (data) => ({
  type: actionTypes.FETCH_ENGLISH_AUCTION_HEADER_DATA_REQUEST,
  payload: data,
});

export const fetchEnglishAuctionHeaderDataSuccess = (data) => ({
  type: actionTypes.FETCH_ENGLISH_AUCTION_HEADER_DATA_SUCCESS,
  payload: data,
});

export const fetchEnglishAuctionHeaderDataFailure = (error) => ({
  type: actionTypes.FETCH_ENGLISH_AUCTION_HEADER_DATA_FAILURE,
  payload: error,
});

export const viewUserWiseLiveEnglishAuctionRequest = (data) => ({
  type: actionTypes.VIEW_USER_WISE_LIVE_ENGLISH_AUCTION_REQUEST,
  payload: data,
});

export const viewUserWiseLiveEnglishAuctionSuccess = (data) => ({
  type: actionTypes.VIEW_USER_WISE_LIVE_ENGLISH_AUCTION_SUCCESS,
  payload: data,
});

export const viewUserWiseLiveEnglishAuctionFailure = (error) => ({
  type: actionTypes.VIEW_USER_WISE_LIVE_ENGLISH_AUCTION_FAILURE,
  payload: error,
});

export const fetchDefaultColumnConfigRequest = (data) => ({
  type: actionTypes.FETCH_DEFAULT_COLUMN_CONFIG_REQUEST,
  payload: data,
});

export const fetchDefaultColumnConfigSuccess = (data) => ({
  type: actionTypes.FETCH_DEFAULT_COLUMN_CONFIG_SUCCESS,
  payload: data,
});

export const fetchDefaultColumnConfigFailure = (error) => ({
  type: actionTypes.FETCH_DEFAULT_COLUMN_CONFIG_FAILURE,
  payload: error,
});

export const fetchEnglishAuctionCenterDataApiCall = (data) => {
  return {
    type: actionTypes.FETCH_ENGLISH_AUCTION_CENTER_DATA_API_CALL,
    payload: data,
  };
};

export const englishcatelogFetchAllData = (data) => {
  return {
    type: actionTypes.ENGLISH_CATELOG_FETCH_ALL_DATA,
    payload: data,
  };
};

export const englishcatelogFetchAllDataSuccess = (data) => {
  return {
    type: actionTypes.ENGLISH_CATELOG_FETCH_ALL_DATA_SUCCESS,
    payload: data,
  };
};

export const englishcatelogFetchAllDataFailure = (error) => {
  return {
    type: actionTypes.ENGLISH_CATELOG_FETCH_ALL_DATA_FAILURE,
    payload: error,
  };
};

export const addCatalogColumnConfigRequest = (data) => {
  return {
    type: actionTypes.ADD_CATALOG_COLUMN_CONFIG_REQUEST,
    payload: data,
  };
};

export const addCatalogColumnConfigSuccess = (data) => {
  return {
    type: actionTypes.ADD_CATALOG_COLUMN_CONFIG_SUCCESS,
    payload: data,
  };
};

export const addCatalogColumnConfigFailure = (error) => {
  return {
    type: actionTypes.ADD_CATALOG_COLUMN_CONFIG_FAILURE,
    payload: error,
  };
};

export const lotWiseBidAcceptRequest = (data) => {
  return {
    type: actionTypes.LOT_WISE_BID_ACCEPT_REQUEST,
    payload: data,
  };
};

export const lotWiseBidAcceptSuccess = (data) => {
  return {
    type: actionTypes.LOT_WISE_BID_ACCEPT_SUCCESS,
    payload: data,
  };
};

export const lotWiseBidAcceptFailure = (data) => {
  return {
    type: actionTypes.LOT_WISE_BID_ACCEPT_FAILURE,
    payload: data,
  };
};

export const fetchRemainingTimeRequest = (data) => ({
  type: actionTypes.FETCH_REMAINING_TIME_REQUEST,
  payload: data,
});

export const fetchRemainingTimeSuccess = (data) => ({
  type: actionTypes.FETCH_REMAINING_TIME_SUCCESS,
  payload: data,
});

export const fetchRemainingTimeFailure = (error) => ({
  type: actionTypes.FETCH_REMAINING_TIME_FAILURE,
  payload: error,
});

export const fetchBidBookRequest = (data) => ({
  type: actionTypes.FETCH_BID_BOOK_REQUEST,
  payload: data,
});

export const fetchBidBookSuccess = (data) => ({
  type: actionTypes.FETCH_BID_BOOK_SUCCESS,
  payload: data,
});

export const fetchBidBookFailure = (error) => ({
  type: actionTypes.FETCH_BID_BOOK_FAILURE,
  payload: error,
});

export const fetchSessionTimeRequest = (data) => ({
  type: actionTypes.FETCH_SESSION_TIME_REQUEST,
  payload: data,
});

export const fetchSessionTimeSuccess = (sessionTime) => ({
  type: actionTypes.FETCH_SESSION_TIME_SUCCESS,
  payload: sessionTime,
});

export const fetchSessionTimeFailure = (error) => ({
  type: actionTypes.FETCH_SESSION_TIME_FAILURE,
  payload: error,
});

export const fetchLotRequest = (data) => ({
  type: actionTypes.FETCH_LOT_REQUEST,
  payload: data,
});

export const fetchLotSuccess = (lotData) => ({
  type: actionTypes.FETCH_LOT_SUCCESS,
  payload: lotData,
});

export const fetchLotFailure = (error) => ({
  type: actionTypes.FETCH_LOT_FAILURE,
  payload: error,
});

export const fetchBidBookSearchDropdownDataRequest = (data) => ({
  type: actionTypes.FETCH_BID_BOOK_SEARCH_DROPDOWN_DATA_REQUEST,
  payload: data,
});

export const fetchBidBookSearchDropdownDataSuccess = (data) => ({
  type: actionTypes.FETCH_BID_BOOK_SEARCH_DROPDOWN_DATA_SUCCESS,
  payload: data,
});

export const fetchBidBookSearchDropdownDataFailure = (error) => ({
  type: actionTypes.FETCH_BID_BOOK_SEARCH_DROPDOWN_DATA_FAILURE,
  payload: error,
});

export const fetchBidBookExportSuccess = (data) => ({
  type: actionTypes.FETCH_BID_BOOK_EXPORT_SUCCESS,
  payload: data,
});

export const fetchBidBookExportFailure = (error) => ({
  type: actionTypes.FETCH_BID_BOOK_EXPORT_FAILURE,
  payload: error,
});

export const viewBidRequest = (data) => ({
  type: actionTypes.VIEW_BID_REQUEST,
  payload: data,
});

export const viewBidSuccess = (data) => ({
  type: actionTypes.VIEW_BID_SUCCESS,
  payload: data,
});

export const viewBidFailure = (error) => ({
  type: actionTypes.VIEW_BID_FAILURE,
  payload: error,
});

export const initiateAddCatalogColumnConfig = (data) => ({
  type: actionTypes.ADD_CATALOG_COLUMN_CONFIG_INITIATE,
  payload: data,
});

export const completeAddCatalogColumnConfig = (response) => ({
  type: actionTypes.ADD_CATALOG_COLUMN_CONFIG_COMPLETE,
  payload: response,
});

export const errorAddCatalogColumnConfig = (error) => ({
  type: actionTypes.ADD_CATALOG_COLUMN_CONFIG_ERROR,
  payload: error,
});
